import React, { useState } from "react";
import "../styles/Navbar.css";
import DarkMode from "./DarkMode";
import { useScrollTo } from "react-use-window-scroll";
import { IoMenu, IoClose } from "react-icons/io5";

function Navbar() {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const scrollTo = useScrollTo();
  return (
    <div className="navbar" id="navbar">
      <div className="logo">DIY!</div>
      <div className="menu">
        <button
          onClick={() => {
            scrollTo({ top: 650, left: 0, behavior: "smooth" });
            closeMobileMenu();
          }}
        >
          About
        </button>
        <button
          onClick={() => {
            scrollTo({ top: 850, left: 0, behavior: "smooth" });
            closeMobileMenu();
          }}
        >
          Skills
        </button>
        <button
          onClick={() => {
            scrollTo({ top: 1300, left: 0, behavior: "smooth" });
            closeMobileMenu();
          }}
        >
          Portfolio
        </button>
        <button
          onClick={() => {
            scrollTo({ top: 3450, left: 0, behavior: "smooth" });
            closeMobileMenu();
          }}
        >
          Contact
        </button>
      </div>

      <div className="toggle">
        <DarkMode />
      </div>
    </div>
  );
}

export default Navbar;
